import { FC } from "react";
import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { styles } from "./stylesFeatureItem";

interface FeatureItemProps {
  label: string;
  textColor?: string;
  iconBgColor: string;
  iconColor: string;
  iconType?: "check" | "close";
}

const FeatureItem: FC<FeatureItemProps> = ({
  label,
  textColor = "#383C40",
  iconBgColor,
  iconColor,
  iconType = "check",
}) => {
  return (
    <Box sx={styles.root}>
      <Box sx={styles.iconWrapper(iconBgColor)}>
        {iconType === "check" ? (
          <CheckIcon sx={{ fontSize: 12, color: iconColor }} />
        ) : (
          <CloseIcon sx={{ fontSize: 12, color: iconColor }} />
        )}
      </Box>

      <Typography sx={styles.text(textColor)}>{label}</Typography>
    </Box>
  );
};

export default FeatureItem;
